const en = {
  nav: {
    logo: 'Tapio Tulenheimo',
    contact: 'Contact',
  },
  hero: {
    line1: 'Psychology. Entrepreneurship.',
    line2: 'Exercise Physiology.',
  },
  profile: {
    title: 'Think like a scientist. Act like an entrepreneur.',
    para1:
      'Science continuously produces new insights into human performance, decision-making, and well-being. Yet few have the ability to apply this knowledge to everyday choices and consistently move toward a higher quality of life.',
    para2:
      'I am a psychologist, exercise physiologist, and entrepreneur. I help entrepreneurs, executives, and teams develop resilience, decision-making, and sustainable performance. My work combines a startup-shaped mindset with scientific perspectives from psychology and exercise physiology.',
    para3: '',
    readMore: 'Read more',
    credentials: 'Tapio Tulenheimo\nPsychologist · Exercise Physiologist · Entrepreneur',
    coaching: 'Coaching',
    speaking: 'Speaking',
  },
  media: {
    label: 'Public Work',
  },
  contact: {
    heading: 'Get in touch',
    linkedIn: 'LinkedIn',
  },
  footer: {
    copyright: '© {year} Tapio Tulenheimo',
  },
  popup: {
    close: 'Close',
    coaching: {
      title: 'Coaching',
      para1:
        'Psychological coaching for entrepreneurs, individuals in leadership positions, and teams. The aim is to develop the best version of yourself both psychologically and physiologically, so that the highest goals in life can be achieved. The coaching relies deeply on research in psychology and exercise science, combined with the results-oriented mindset shaped by the startup world.',
      para2:
        "If you're interested in coaching, send an email to the address below. After that, we'll schedule a short discovery call to go through potential collaboration. The call is free of charge and does not commit you to anything.",
    },
    speaking: {
      title: 'Speaking',
      para1:
        'Talks and keynotes that combine entrepreneurial thinking with practical science from psychology and exercise physiology — to help people perform better, think clearer, and lead sustainably. Designed for companies, leadership teams, and events.',
      para2:
        'I focus on ideas you can actually use the next day: decision-making, resilience, habit design, sustainable performance, and well-being under pressure. If this sounds relevant for your team or event, feel free to reach out by email.',
    },
    about: {
      title: 'About',
      para1:
        'I am trained as a psychologist (University of Helsinki) and an exercise physiologist (University of Jyväskylä). As an entrepreneur, I currently operate in our technology company AITOFIT. My entrepreneurial path has also included a broad range of expertise, from clinical psychology practice to educating professionals in the fitness industry.',
      para2:
        'My passion lies in understanding human physiological and psychological capacity and in applying psychological and physiological research evidence to everyday life.',
      para3:
        'The startup world has taught me at least as much as the academic community. Success requires continuous self-improvement, and teamwork must be highly innovative and seamless.',
      para4:
        'In my coaching and speaking, research-based psychological and exercise science knowledge is combined with practical experience from the business world. The goal is to help individuals and teams make better decisions, strengthen resilience, and build sustainable performance without compromising well-being.',
      para5: '',
    },
    media: {
      title: 'Public Work',
      intro1: 'An overview of my public work across media, podcasting, and ventures.',
      intro2:
        'Most of these have been created together with my long-time founder partner, Julius Granlund (our company AITOFIT and podcast Psykalab, and most of the articles related to our common work).',
      companyLabel: 'Our company: AITOFIT',
      companyUrl: 'https://www.aitofit.io/',
      links: [
        { name: 'Our podcast: Psykalab', url: 'https://open.spotify.com/show/3UtitB2xAeMKCilwjKCoba?si=1c66001ce37a4d53' },
        { name: 'Talouselämä: Yrityksen perustaneet Julius Granlund ja Tapio Tulenheimo myivät autonsa ja vetivät tilinsä rumasti miinukselle – sitten tuli huima kasvu', url: 'https://www.talouselama.fi/uutiset/a/6185f925-25e5-4e96-a06a-5715efa299c6' },
        { name: 'Helsingin Sanomat: Jyväskylän maisterit maailmanvalloitukseen', url: 'https://www.hs.fi/urheilu/art-2000010018747.html' },
        { name: 'Helsingin Sanomat: Valmentaja puhelimessa', url: 'https://www.hs.fi/hyvinvointi/art-2000010292988.html' },
        { name: 'Keski-Suomalainen: Kahden jyväskyläläisen liikuntabiologin opit saliharjoittelusta jalostuivat innovaatioksi', url: 'https://www.ksml.fi/paikalliset/5988861' },
        { name: 'JYU: Alumniesittelyssä Julius Granlund ja Tapio Tulenheimo', url: 'https://www.jyu.fi/fi/tarina/alumniesittelyssa-julius-granlund-ja-tapio-tulenheimo' },
        { name: 'MTV: Miksi lihaksiin koskee treenin jälkeen? Ei kerro palautumisesta mitään', url: 'https://www.mtvuutiset.fi/artikkeli/miksi-lihaksiin-koskee-treenin-jalkeen-ei-kerro-palautumisesta-mitaan/8862828' },
        { name: 'MTV: Yllättävä jippo voi mullistaa penkkipunnerruksesi?', url: 'https://www.mtvuutiset.fi/artikkeli/yllattava-jippo-voi-mullistaa-penkkipunnerruksesi-kehonrakennuksen-kummiseta-saa-vastauksen-suomesta/9273804' },
        { name: 'Lihastohtori-blogi: Penkkipunnerrus – osa I', url: 'https://lihastohtori.wordpress.com/2020/01/25/penkkipunnerrus1/' },
        { name: 'Lihastohtori-blogi: Penkkipunnerrus – Osa II', url: 'https://lihastohtori.wordpress.com/2020/03/04/penkki_tekniikka/' },
        { name: 'Lihastohtori-blogi: Uskomusten voima', url: 'https://lihastohtori.wordpress.com/2023/11/02/uskomusten-voima-plasebo-ja-nosebovaikutukset/' },
        { name: 'Anna-Lehti: Näin kävi, kun tekoäly laati salitreeniohjelman', url: 'https://anna.fi/hyvinvointi/liikunta/aitofit-kokemuksia' },
      ],
    },
  },
  seo: {
    title: 'Tapio Tulenheimo – Psychologist and Exercise Physiologist',
    description:
      'Psychologist, exercise physiologist and entrepreneur. Lectures, coaching and speaking on how to turn psychological and physiological research into practical tools and achieve ambitious goals.',
    ogTitle: 'Tapio Tulenheimo – Psychologist and Exercise Physiologist',
    ogDescription:
      'Psychologist, exercise physiologist and entrepreneur. Lectures, coaching and speaking on how to turn psychological and physiological research into practical tools and achieve ambitious goals.',
  },
};

export default en;
